import React from "react";
import InlineSVG, { Props as InlineSvgProps } from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../helpers/AssetHelpers/AssetHelpers";
type Props = {
  className?: string;
  path: string;
  svgClassName?: string;
};

const SVG: React.FC<InlineSvgProps> = (props) => {
  return React.createElement(InlineSVG as any, props);
};

const KTSVG: React.FC<Props> = ({
  className = "",
  path,
  svgClassName = "mh-50px",
}) => {
  return (
    <span className={`svg-icon ${className}`}>
      <SVG src={toAbsoluteUrl(path)} className={svgClassName} />
    </span>
  );
};

export { KTSVG };
